import * as dotWasm from "@hpcc-js/wasm";
import classNames from "classnames";
import { observer } from "mobx-react-lite";
import React, { useEffect, useRef, useState } from "react";
import { throttle, useSyncRef } from "../Utils";

dotWasm.wasmFolder("/wasm/");
export const GraphvizRender = observer(({ value }: { value: string }) => {
  const rootRef = useRef<HTMLDivElement | null>(null);
  const [renderedValue, setRenderedValue] = useState<string | undefined>(
    undefined
  );
  const [error, setError] = useState<string | undefined>(undefined);
  const valueRef = useSyncRef(value);
  const [throttleRenderValue] = useState(() =>
    throttle(async (value: string) => {
      try {
        setError(undefined);
        const svg = await dotWasm.graphviz.layout(value, "svg", "dot");
        if (valueRef.current === value && rootRef.current !== null) {
          rootRef.current.innerHTML = svg;
          setRenderedValue(value);
          const svgElement = rootRef.current!.querySelector("svg")!;
          svgElement.style.width = "100%";
          svgElement.style.height = "100%";
        }
      } catch (e: any) {
        if (valueRef.current === value) {
          setError(e.toString());
        }
      }
    }, 300)
  );
  useEffect(() => {
    throttleRenderValue(value);
  }, [value]);

  return (
    <div className="h-full">
      {error !== undefined ? (
        <div className="text-red-500 p-2">{error}</div>
      ) : null}
      <div
        className={classNames("h-full", {
          "opacity-50": renderedValue !== value,
          hidden: error !== undefined,
        })}
        ref={rootRef}
      />
    </div>
  );
});
